import { FormProvider } from "react-hook-form";
import { AppDialog } from "../../../../common/components/AppDialog/AppDialog";
import { DefaultButton } from "../../../../common/components/button/defaultButton/DefaultButton";
import { DefaultInputField } from "../../../../common/components/forms/inputs/InputField/DefaultInputField";
import { InputDateField } from "../../../../common/components/forms/inputs/inputDateField/InputDateField";
import { CurrencyType } from "../../../../common/enums";
import { useGiftVoucherFormDialog } from "../hooks/useGiftVoucherFormDialog";
import { IGiftVoucherModel } from "../models/giftVoucherModels";
import styles from "./GiftVoucherFormDialog.module.scss";

interface IGiftVoucherFormDialogProps {
  /** Null = create a new voucher. A voucher = edit it (only allowed while unsold). */
  voucher: IGiftVoucherModel | null;
  visible: boolean;
  onHide: () => void;
}

export const GiftVoucherFormDialog = ({
  voucher,
  visible,
  onHide,
}: IGiftVoucherFormDialogProps) => {
  const { form, isLoading, headerLabel, confirmLabel, today, handleSubmit } =
    useGiftVoucherFormDialog({ voucher, visible, onHide });

  return (
    <AppDialog
      header={headerLabel}
      visible={visible}
      className={styles.dialog}
      onHide={onHide}
      tooltip={
        "Създаването на ваучер не движи пари. Ваучерът става задължение чак когато " +
        "бъде продаден през касата."
      }
      // The form holds typed work; a stray click on the backdrop should not lose it.
      dismissableMask={false}
    >
      <FormProvider {...form}>
        <form className={styles.form} onSubmit={handleSubmit}>
          <DefaultInputField
            name="name"
            label="Име"
            placeholder="напр. Подарък за рожден ден"
            required
            width="100%"
          />

          <DefaultInputField
            name="amount"
            label="Стойност"
            placeholder="0.00"
            type="number"
            min={0}
            step={0.01}
            currency={CurrencyType.EUR}
            required
            width="100%"
          />

          <InputDateField
            name="validUntil"
            label="Валиден до"
            placeholder="Безсрочен"
            width="100%"
            minDate={today}
            clearable
          />

          <p className={styles.form_hint}>
            Остави датата празна, ако ваучерът е безсрочен. Ваучерът може да се използва
            само в този обект.
          </p>

          <div className={styles.form_footer}>
            <DefaultButton
              label={confirmLabel}
              type="submit"
              loading={isLoading}
              width="100%"
            />
          </div>
        </form>
      </FormProvider>
    </AppDialog>
  );
};
